/*
 * Polyfills: See babel.config.js
 * It is preferable to only select needed polyfills there.
 * If this is not enough and you don’t find the right polyfill,
 * uncommenting "@babel/polyfill" might help.
 */
// import '@babel/polyfill';
// import 'promise-polyfill/src/polyfill';
import Vue from 'vue';
import vClickOutside from 'v-click-outside';
import VTooltip from 'v-tooltip';
import * as log from 'loglevel';

// import { Drop } from 'vue-drag-drop';
// import VueDraggableResizable from 'vue-draggable-resizable';
/*
 * importing the stylesheet from node_modules did not work in production,
 * therefore the code was copy'n'pasted to the KDLayout.vue file.
 * If the library is updated, the CSS must be manually copied into the KDLayout component.
 */
// import 'vue-draggable-resizable/dist/VueDraggableResizable.css';

import Kartendesigner from './Kartendesigner.vue';
import store from './store';
import KdQueryParser from '@/services/KdQueryParser';
import CardLoader from '@/services/CardLoader';

// Set log levels (can be overwritten for each component)
// in production / state mode only warn and error logs go through
if (process.env.NODE_ENV === 'development') {
  log.setLevel(log.levels.TRACE);
} else {
  log.setLevel(log.levels.WARN);
}

Vue.config.productionTip = false;

Vue.use(vClickOutside);
Vue.use(VTooltip);
// Vue.component('drop', Drop);

// Vue.component('vue-draggable-resizable', VueDraggableResizable);

new Vue({
  store,
  render: h => h(Kartendesigner),
}).$mount('#kartendesigner');

const cardLoader = new CardLoader(store);

window.kartendesigner = {
  loadCard: cardLoader.loadCard.bind(cardLoader),
  onAddToWishlist: null, // needs to be implemented on the other side
  onAddToCart: null, // needs to be implemented on the other side
  // vuex: store, // in case the vuex store needs to be accessed globally
};

const queryParser = new KdQueryParser(store);
/*
 * Example:
 * ?print=true&card=abcdefg
 */
queryParser.parse(window.location.search)
  .then((parsedQuery) => {
    if (parsedQuery) {
      if (parsedQuery.card) {
        cardLoader.loadCard(parsedQuery.card, {
          print: parsedQuery.print,
          sideId: parsedQuery.sideId,
        }).then(() => {
          if (parsedQuery.print) {
            store.commit('SET_PRINT_MODE_TO_TRUE');
          }
          if (parsedQuery.screenshot) {
            store.commit('SET_SCREENSHOT_MODE_TO_TRUE');
          }
          if (parsedQuery.sideId) {
            store.dispatch('ACTIVATE_SIDE_BY_ID', parsedQuery.sideId);
          }
        });
      }
      // Set logging library to DEBUG when "debug" is passed as URL parameter
      if (parsedQuery.debug) {
        log.setLevel(log.levels.TRACE);
      }
    }
  });
